<template>
    <button type="text" class="outline-none"
    @click.prevent="($event) => $emit('click', $event)">
        <span :class="`text-${textColor} font-bold text-sm`">
            <slot/>
        </span>
    </button>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'muted',
    },
  },
  computed: {
    textColor() {
      let color = '';
      switch (this.theme) {
        case 'red':
          color = 'danger';
          break;
        case 'blue':
          color = 'secondary';
          break;
        case 'green':
          color = 'primary';
          break;
        default:
          color = 'muted';
          break;
      }
      return color;
    },
  },
};
</script>
